import { getUserInfo } from "@/lib/token";
import { apiServices } from "@/services/api.services";
import { useMemo } from "react";
import { useToast } from "./use-toast";
import { useProcess } from "@/global-data";
import { getFileUrl } from "@/lib/get-file-url";
import { documentsUpload } from "@/services/global.services";

/* eslint-disable @typescript-eslint/no-explicit-any */
export const useImportExport = ({
  API_SERVICE,
  loadingList,
}: {
  API_SERVICE: any;
  loadingList: any;
}) => {
  const { toast } = useToast();

  const { setProcess } = useProcess();

  const onRunDocument = async (prop: any): Promise<any> => {
    setProcess(true);

    const payload = {
      data: { file_path: prop },
      company_id: company_id,
      user_id: user_id,
    };

    const { data, error, message /* statusCode */ } = await apiServices<any>(
      API_SERVICE.import,
      "post",
      payload,
    );

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  const { company_id, user_id } = useMemo(() => {
    const tempUserData = getUserInfo();
    return {
      company_id: tempUserData?.company_id,
      user_id: tempUserData?.user_id || "",
    };
  }, []);

  const importDocument = async (prop: any) => {
    if (!prop) return;
    setProcess(true);
    const payload = new FormData();

    payload.append("files", prop);

    const { data, error, message /* statusCode */ } = await apiServices<any>(
      documentsUpload.post + "/" + company_id,
      "post",
      payload,
    );

    if (data) {
      const runDocument = await onRunDocument(data.metadata.file_path);

      await loadingList({});
      toast({
        title: "Success",
        variant: "success",
        description: runDocument?.data?.result?.metadata?.message,
      });
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    setProcess(false);
  };

  const exportDocument = async () => {
    setProcess(true);
    const payload = {
      data: {},
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message /* error, message, statusCode */ } =
      await apiServices<any>(API_SERVICE.export, "post", payload);

    console.log({ data, error, message });
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }

    if (data) {
      const listData = data.result.metadata.export_path;
      const url = await getFileUrl(listData);

      console.log({ url });
      downloadImage(url);
    }
    setProcess(false);
  };

  function downloadImage(url: string) {
    // Create an anchor element
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = "downloaded-document";

    // Append the anchor to the document body
    document.body.appendChild(anchor);

    // Programmatically click the anchor to trigger the download
    anchor.click();

    // Remove the anchor from the document
    document.body.removeChild(anchor);
  }

  return { importDocument, exportDocument };
};
